import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRouter from "./router";
import { AuthProvider } from "./features/auth/store/authSlice";
import { AnalysisProvider } from "./features/dashboard/store/analysisContext";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AnalysisProvider>
          <AppRouter />
        </AnalysisProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;